import { render, staticRenderFns } from "./SidebarConsent.vue?vue&type=template&id=afb54c7e&scoped=true"
import script from "./SidebarConsent.vue?vue&type=script&lang=js"
export * from "./SidebarConsent.vue?vue&type=script&lang=js"
import style0 from "./SidebarConsent.vue?vue&type=style&index=0&id=afb54c7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb54c7e",
  null
  
)

export default component.exports